module.exports = __webpack_public_path__ + "img/wallet-light.922c0ed1.svg";